import { Context } from '../../../common'
import { Api, ConsumptionRatesApi, HttpClient } from '../../../api'
import { ProductCategory } from '../../productCategories'
import {
  ConsumptionRate,
  ConsumptionRates,
  ConsumptionRatesService,
  DEFAULT_AVERAGE_RATE_BY_CATEGORY,
  MAX_COUPONS_BY_CATEGORY,
} from './consumptionRates'
import { forEach } from 'lodash'

function mapDtoToConsumptionRate(dto: Api.ConsumptionRates): ConsumptionRates {
  const consumptionRates: Partial<ConsumptionRates> = {}

  forEach(ProductCategory, p => {
    consumptionRates[p] = {
      averageRate: dto[p].averageRate ?? DEFAULT_AVERAGE_RATE_BY_CATEGORY[p],
      couponsCountPerMonth: dto[p].couponsCountPerMonth ?? MAX_COUPONS_BY_CATEGORY[p],
    }
  })

  return consumptionRates as ConsumptionRates
}

export class RemoteConsumptionRatesService implements ConsumptionRatesService {
  private api: ConsumptionRatesApi

  constructor(httpClient: HttpClient) {
    this.api = new ConsumptionRatesApi(httpClient, undefined, '')
  }
  async get(ctx: Context): Promise<ConsumptionRates> {
    const result = await this.api.consumptionRatesGetObject(ctx)

    return mapDtoToConsumptionRate(result.body.object)
  }

  async updateByProductCategory(
    ctx: Context,
    productCategory: ProductCategory,
    opts: Partial<ConsumptionRate>,
  ): Promise<void> {
    await this.api.consumptionRatesUpdate(ctx, productCategory, opts)
  }
}
